import { useId } from "react";
import { MultiCheckbox } from "@sprout/checkbox.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import Button from "@sprout/button.tsx";
import CaretIcon from "@sprout/icons/caret.tsx";
import { SpecializedMultiSelectFilterProps } from "@components/job_search/filters/multi_select_filter.tsx";

export const DesktopMultiSelectFilter = ({
  buttonText,
  onSelect,
  options,
  values,
}: SpecializedMultiSelectFilterProps) => {
  const id = useId();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="medium" className="inline-flex items-center justify-between gap-1">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <CaretIcon size="sm" color="green" />
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={0} className="pt-4 pb-6 px-6">
        <div className="flex items-center w-48">
          <MultiCheckbox
            id={id}
            options={options}
            isMulti={true}
            onSelect={onSelect}
            values={values}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
